import { render, staticRenderFns } from "./ButtonApp.vue?vue&type=template&id=a78b5d8c&scoped=true"
import script from "./ButtonApp.vue?vue&type=script&lang=js"
export * from "./ButtonApp.vue?vue&type=script&lang=js"
import style0 from "./ButtonApp.vue?vue&type=style&index=0&id=a78b5d8c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78b5d8c",
  null
  
)

export default component.exports